import { LifeBuoy } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const LifeBuoyIcon = createLucideIcon(LifeBuoy);
